<header>
  <div class="heron-header-img-wrapper">
    <img
      [src]="tenantConfigService.desktopLogoUrl"
      [alt]="tenantConfigService.config.productName + ' logo'"
      role="img"
      [attr.aria-label]="tenantConfigService.config.productName + ' logo'"
      loading="lazy"
    />
    <div class="logo-separator"></div>
    <img
      src="assets/img/B_Corp_logo.svg"
      alt="B-Corp logo"
      role="img"
      aria-label="B-Corp logo"
      loading="lazy"
      class="bcorp_logo"
    />
  </div>
</header>

<div class="container">
  <div class="result-container">
    <div class="result-container_information">
      <svg class="icon" [ngClass]="statusClass" [attr.width]="imageWidth" [attr.height]="imageHeight">
        <use [attr.xlink:href]="getStatusIcon()"></use>
      </svg>

      <ng-container *ngIf="resultTitle">
        <h1 class="text-h1-medium-grey24">
          {{ resultTitle }}
        </h1>
      </ng-container>

      <ng-container *ngIf="resultSubMessage">
        <h4 class="message">
          {{ resultSubMessage }}
        </h4>
      </ng-container>
    </div>
  </div>
</div>

<footer>
  <ng-container *ngIf="!isStandalone"
  >
    <div class="buttons">
      <hfc-button type="primary" (click)="onReturnClicked()">Return to Dashboard</hfc-button>
    </div>
  </ng-container>
</footer>
